import Vue from "vue";
import { TRANSLATABLE_TRANSACTION_TYPES } from "../enum/transaction";

Vue.filter("transaction_type", value => {
  let transaction_type = TRANSLATABLE_TRANSACTION_TYPES.find(
    x => x.key === value
  );
  if (!transaction_type) {
    return null;
  }
  return transaction_type.translation;
});
